export const LINKS = {
  SAAS: "https://draivn.com/saas-agreement",
  AGREEMENT: "https://draivn.com/license-agreement",
};
